import { useEffect, useState } from "react";
import api from "@/lib/api";

let cachedInfo = null;
let inflight = null;

async function fetchBusinessInfo() {
  if (cachedInfo) return cachedInfo;
  if (!inflight) {
    inflight = api
      .get("/business-info")
      .then((r) => {
        cachedInfo = r.data;
        return cachedInfo;
      })
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

export function useBusinessInfo() {
  const [info, setInfo] = useState(cachedInfo);
  useEffect(() => {
    let mounted = true;
    if (!cachedInfo) {
      fetchBusinessInfo()
        .then((data) => {
          if (mounted) setInfo(data);
        })
        .catch(() => {
          if (mounted) setInfo(null);
        });
    }
    return () => {
      mounted = false;
    };
  }, []);
  return info;
}

export { fetchBusinessInfo };
